<ui-section style="min-height:100px;">
      <ui-block width="fill">
        <p>Section and block sample components. Use the Dev Mode switch in the footer to see the layout details.</p>
        <p>Blocks can be sized with the <code>width</code> attribute.</p>
      </ui-block>
    </ui-section>

    <ui-section style="min-height:400px;" class="outline outline-cyan-500">
      <ui-block width="1x" class="outline outline-blue-500">This is a 1x block. The width should never change.</ui-block>
      <ui-block width="2x" class="outline outline-blue-500">This is a 2x block. The width should never change.</ui-block>
      <ui-block width="fill" class="outline outline-green-700">This is a fill block. The width will grow and shrink as necessary so that the containing section is filled</ui-block>
      <ui-block width="3x" class="outline outline-blue-500">This is a 3x block. The width should never change.</ui-block>
</ui-section>